<script lang="ts">
    import Esi from '@shared/components/esi/Esi.svelte';
    import type { Page } from '@shared/types/Tilelist.ts';

    interface Props {
        rule: string;
        page: Page;
    }

    let { rule, page }: Props = $props();

    /*                                                                           */
    /*                                     */
    const refinementBarInclude = page.sortiertnach
        ? `/leafcutter/refinementbar?rule=${encodeURIComponent(rule)}&sortiertnach=${page.sortiertnach}`
        : `/leafcutter/refinementbar?rule=${encodeURIComponent(rule)}`;
</script>

<Esi src={refinementBarInclude} />
